export default {
    "sword": {
        "key": "sword",
        "name": "Sword",
        "strengths": ["gun", "axe"],
        "weaknesses": ["spear", "bow"],
        "color": "#d54b33",
    },
    "dagger": {
        "key": "dagger",
        "name": "Dagger",
        "strengths": ["axe", "gun"],
        "weaknesses": ["spear", "bow"],
        "color": "#d54b33",
    },
    "axe": {
        "key": "axe",
        "name": "Axe",
        "strengths": ["spear", "bow"],
        "weaknesses": ["sword", "dagger"],
        "color": "#62C370",
    },
    "gun": {
        "key": "gun",
        "name": "Gun",
        "strengths": ["spear", "bow"],
        "weaknesses": ["sword", "dagger"],
        "color": "#62C370",
    },
    "spear": {
        "key": "spear",
        "name": "Spear",
        "strengths": ["sword", "dagger"],
        "weaknesses": ["axe", "gun"],
        "color": "#639bff",
    },
    "bow": {
        "key": "bow",
        "name": "Bow",
        "strengths": ["sword", "dagger"],
        "weaknesses": ["axe", "gun"],
        "color": "#639bff",
    },



    "fire": {
        "key": "fire",
        "name": "Fire",
        "strengths": ["earth"],
        "weaknesses": ["water"],
        "color": "#d54b33",
    },
    "earth": {
        "key": "earth",
        "name": "Earth",
        "strengths": ["water"],
        "weaknesses": ["fire"],
        "color": "#62C370",
    },
    "water": {
        "key": "water",
        "name": "Water",
        "strengths": ["fire"],
        "weaknesses": ["earth"],
        "color": "#639bff",
    },
    "light": {
        "key": "light",
        "name": "Light",
        "strengths": ["dark"],
        "weaknesses": ["dark"],
        "color": "#F2CC8F",
    },
    "dark": {
        "key": "dark",
        "name": "Dark",
        "strengths": ["light"],
        "weaknesses": ["light"],
        "color": "#6D466B",
    },
    "undefined": {
        "key": undefined,
        "name": "Null",
        "strengths": [],
        "weaknesses": [],
        "color": "gray"
    },
    "null": {
        "key": undefined,
        "name": "Null",
        "strengths": [],
        "weaknesses": [],
        "color": "gray"
    }
}
